import { createSection } from '../createSection'

/**
 * Inner section
 *
 * @public
 */
export const inner = createSection('inner', 'div')
